<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.mobile" v-model="dialog" persistent :max-width="576">
    <v-card>
      <v-toolbar color="#FFB300" dense class="elevation-0" dark>
        <v-toolbar-title>Sửa khoản thu</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-5">
        <production-edit-form :p="p" ref="form" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="width: 96px" text color="primary" @click="cancel">Hủy</v-btn>
          <v-btn style="width: 96px" color="primary" @click="save">Lưu</v-btn>
        </v-card-actions></v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import ProductionEditForm from '@/components/basic/form/ProductionEditForm.vue'

export default {
  components: { ProductionEditForm },
  data: () => ({
    dialog: false,
  }),
  props: {
    state: Boolean,
    p: Object,
  },
  methods: {
    ...mapActions('product', ['fetchProducts']),
    ...mapActions('product', ['updateProduct', 'fetchProducts']),
    async save() {
      this.loading = true
      const data = this.$refs.form.getData()
      console.log(data)
      await this.updateProduct({
        id: this.p.id,
        ...data,
      })
      this.dialog = false
      this.reset()
    },

    cancel() {
      this.reset()
      this.$emit('cancel')
      this.dialog = false
    },
    reset() {
      this.$refs.form.reset()
    },
  },
  watch: {
    state(state) {
      this.dialog = true
    },
  },
}
</script>
<style scoped></style>
